function veda_fn_id_4ea840f8d87242d286d3552d87231569() {
    
    try {
      const uniqueId = /* _____Start/Id_____ */"id_4ea840f8-d872-42d2-86d3-552d87231569"/* _____End/Id_____ */;
      const containers = document.querySelectorAll(`[data-id="${uniqueId}"]:not(addons, megamenu)`);
      containers.forEach(container => {
        if (!container) {
          return;
        }
        veda.plugins.videoCover(container);
        /* _____Start/Content_____ */
        
        /* _____End/Content_____ */
      });
    } catch (error) {
      console.log(error);
    }
  };
veda_fn_id_4ea840f8d87242d286d3552d87231569();
